document.addEventListener("DOMContentLoaded", function () {
    // Copy all the other sections into How It Works tab (desktop & mobile)
    let sections = document.querySelectorAll('.image-with-text-block-main, .image-video-style, .section-accordion, .image-text-style');
    let desktopTab = document.querySelector('.tabs_content .howitworks');
    let mobileTab = document.querySelector('.accordian .howitworks');

    if (!sections || !desktopTab) {
        return;
    }

    sections.forEach(section => {
        desktopTab.appendChild(section.cloneNode(true));
        mobileTab.appendChild(section.cloneNode(true));

        section.remove();
    });

    desktopTab.querySelectorAll('.skin-images .swiper').forEach(swiper => {
        swiper.swiper = new Swiper(swiper, {
            "loop": false,
            "shortSwipes": false,
            "slidesPerView": "1",
            "observer": true,
            "observeParents": true,
            "spaceBetween": 15,
            "freeMode": true,
            "grabCursor": true,
            "navigation": {
                "nextEl": ".product-button-next",
                "prevEl": ".product-button-prev"
            },
            "pagination": {
                "el": ".swiper-pagination"
            },
            "breakpoints": {
                "560": {
                    "slidesPerView": 1.5
                },
                "768": {
                    "slidesPerView": 3,
                    "spaceBetween": 60
                },
                "992": {
                    "slidesPerView": 4,
                    "spaceBetween": 60
                }
            }
        });
    });

    mobileTab.querySelectorAll('.skin-images .swiper').forEach(swiper => {
        swiper.swiper = new Swiper(swiper, {
            loop: false,     
            shortSwipes: false,
            "observer": true,
            "observeParents": true,
            "freeMode": true,
            "grabCursor": true,            
            slidesPerView: 'auto',
            resistanceRatio: 0,
            spaceBetween: 40,
            navigation: {
                "nextEl": ".product-button-next",
                "prevEl": ".product-button-prev"
            },
            pagination: {
                "el": ".swiper-pagination"
            },
            breakpoints: {
                "768": {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                "992": {
                    slidesPerView: 4,
                    spaceBetween: 60
                }
            }
        });
    });
});